import * as React from 'react';
import { FormGroup, Input as ReactStrapInput } from 'reactstrap';
import { FieldRenderProps } from 'react-final-form';
import { ValidationMessages } from 'components/shared/edit/fields';
import { InputType } from 'reactstrap/lib/Input';

/**
 * Component that renders a Reactstrap input for login screens.
 *
 * @class Input
 * @extends {(React.Component<FieldRenderProps>)}
 */
class Input extends React.Component<FieldRenderProps<any, HTMLInputElement>> {
	constructor(props) {
		super(props);
	}

	public render() {
		const {
			input: { name, onChange, value, onBlur, onFocus, type },
			meta,
			...rest
		} = this.props;

		return (
			<FormGroup>
				<div className="input-wrapper">
					<ReactStrapInput
						id={name}
						type={type as InputType}
						name={name}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						onFocus={onFocus}
						invalid={!meta.dirtySinceLastSubmit && meta.submitError ? true : false}
						aria-describedby={name + '-invalid'}
						{...rest}
					/>
				</div>

				<ValidationMessages id={name + '-invalid'} meta={meta} />
			</FormGroup>
		);
	}
}

export default Input;
